var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreen600Construction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_3119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8776 9.03374L9.46338 10.4479L13.4609 14.4454L14.8751 13.0312L10.8776 9.03374Z",
    fill: "#214E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9416 7.00001C13.2283 7.00001 14.2749 5.95335 14.2749 4.66668C14.2749 4.28001 14.1683 3.92001 14.0016 3.60001L12.2016 5.40001L11.2083 4.40668L13.0083 2.60668C12.6883 2.44001 12.3283 2.33335 11.9416 2.33335C10.6549 2.33335 9.60826 3.38001 9.60826 4.66668C9.60826 4.94001 9.66159 5.20001 9.74826 5.44001L8.51493 6.67335L7.32826 5.48668L7.80159 5.01335L6.86159 4.07335L8.27493 2.66001C7.49493 1.88001 6.22826 1.88001 5.44826 2.66001L3.08826 5.02001L4.02826 5.96001H2.14826L1.67493 6.43334L4.03493 8.79334L4.50826 8.32001V6.43334L5.44826 7.37335L5.92159 6.90001L7.10826 8.08668L2.16826 13.0267L3.58159 14.44L11.1683 6.86001C11.4083 6.94668 11.6683 7.00001 11.9416 7.00001Z",
    fill: "#214E34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_3119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.274902 0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen600Construction);
export default __webpack_public_path__ + "static/media/green_600_construction.f474b4bbabf8b8d56162982d21754df3.svg";
export { ForwardRef as ReactComponent };